import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import Box from '../Box';
import Button from '../Button';
import StackView from '../StackView';
import { range } from '../utils';

function getVisiblePages(currentPage, totalPages, visiblePages) {
  var start = Math.max(1, Math.min(totalPages - visiblePages + 1, currentPage - visiblePages / 2 + 1));
  var stop = Math.min(totalPages, start + visiblePages - 1);
  var primaryWindow = range(start, stop + 1);
  var showFirstPage = start > 1;
  var showLastPage = stop < totalPages;

  if (showFirstPage) {
    primaryWindow.shift();
    primaryWindow.shift();
  }

  if (showLastPage) {
    primaryWindow.pop();
    primaryWindow.pop();
  }

  var first = showFirstPage ? [1, '...'] : [];
  var last = showLastPage ? ['...', totalPages] : [];
  return first.concat(primaryWindow).concat(last);
}

var Pagination = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Pagination, _Component);

  function Pagination() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Pagination.prototype;

  _proto.renderGap = function renderGap(key) {
    return /*#__PURE__*/React.createElement(Box, {
      key: key,
      userSelect: "none",
      cursor: "default",
      children: "\u2026"
    });
  };

  _proto.renderPageLink = function renderPageLink(number) {
    var isActive = this.props.currentPage === number;
    return /*#__PURE__*/React.createElement(Button, {
      key: number,
      onClick: this.props.onPageChange.bind(null, number),
      theme: isActive ? this.props.activeColor : undefined,
      variant: isActive ? 'fill' : 'naked',
      title: number,
      shrink: 0,
      square: true
    });
  };

  _proto.renderPageLinks = function renderPageLinks() {
    var _this = this;

    var pages = getVisiblePages(this.props.currentPage, this.props.totalPages, this.props.visiblePages);
    return pages.map(function (page, index) {
      return page === '...' ? _this.renderGap(page + index) : _this.renderPageLink(page);
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        activeColor = _this$props.activeColor,
        currentPage = _this$props.currentPage,
        totalPages = _this$props.totalPages,
        visiblePages = _this$props.visiblePages,
        onPageChange = _this$props.onPageChange,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["activeColor", "currentPage", "totalPages", "visiblePages", "onPageChange"]);

    if (totalPages <= 1) {
      return null;
    }

    return /*#__PURE__*/React.createElement(StackView, _extends({
      axis: "horizontal",
      alignment: "center",
      distribution: "center",
      width: "100%",
      paddingVertical: 1,
      shrink: 0,
      overflow: "auto"
    }, restProps), /*#__PURE__*/React.createElement(Button, {
      onClick: onPageChange.bind(null, currentPage - 1),
      disabled: currentPage === 1,
      icon: {
        name: 'caret-left'
      },
      tooltip: {
        title: 'Previous Page'
      },
      variant: "naked",
      shrink: 0
    }), this.renderPageLinks(), /*#__PURE__*/React.createElement(Button, {
      onClick: onPageChange.bind(null, currentPage + 1),
      disabled: currentPage === totalPages,
      icon: {
        name: 'caret-right'
      },
      tooltip: {
        title: 'Next Page'
      },
      variant: "naked",
      shrink: 0
    }));
  };

  return Pagination;
}(Component);

_defineProperty(Pagination, "defaultProps", {
  activeColor: 'primary',
  onPageChange: function onPageChange() {
    return null;
  },
  visiblePages: 8,
  totalPages: 0
});

export default Pagination;